import {ContentCommentLikeVerboseDomain} from "../../domain/content/ContentCommentLikeVerboseDomain"
import {ContentCommentId} from "../../id/content/ContentCommentId"
import {ContentCommentLikeId} from "../../id/content/ContentCommentLikeId"
import {UserId} from "../../id/user/UserId"
import {UserValueObject} from "../user/UserValueObject"
import {ContentCommentValueObject} from "./ContentCommentValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 댓글 좋아요 상세
 */
export class ContentCommentLikeVerboseValueObject implements VerboseValueObject, ContentCommentLikeVerboseDomain {
    /**
     * 기본키
     */
    id: ContentCommentLikeId
    /**
     * 댓글 ID
     */
    contentCommentId: ContentCommentId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 댓글 ID
     */
    contentComment: ContentCommentValueObject
    /**
     * 사용자 ID
     */
    user: UserValueObject

    constructor(o: Record<keyof ContentCommentLikeVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.contentCommentId = BigInt(o.contentCommentId)
        this.userId = BigInt(o.userId)
        this.createdAt = new Date(o.createdAt)
        this.contentComment = new ContentCommentValueObject(o.contentComment)
        this.user = new UserValueObject(o.user)
    }
}
